import React from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'

export const MyReports = ({ setHistoryActiveTab }) => {
  const location = useLocation();
  const roomId = new URLSearchParams(location.search).get("clientId");
  const navigate = useNavigate();
  const handleCapitalGain = () => {
    setHistoryActiveTab("ReportClieck");

    setTimeout(() => {
      navigate("/capital-gain-report?clientId=" + roomId);
    }, 0);
  };

  return (
    <>
     <div class="row pt-5 text-center bggrey">
            <div class="col-12">
              <button class="lrgbutton text-white" onClick={handleCapitalGain}>Capitals gain report</button>
            </div>
            <div class="col-12 pt-3">
              <button class="lrgbutton text-white">Transaction Log</button>
            </div>
          </div>
    </>
  )
}
